import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import ReactModal from 'react-modal';

import Box from '../box/box.jsx';
import Button from '../button/button.jsx';

import styles from './modal.css';
import iconFont from '../../css/iconfont.css';

const ModalComponent = props => (
    <ReactModal
        isOpen
        className={classNames(styles.modalContent, props.className)}
        contentLabel={props.contentLabel}
        overlayClassName={classNames(styles.modalOverlay, {[props.overlayClassName]: props.overlayClassName})}
        onRequestClose={props.onRequestClose}
    >
        <Box
            className={styles.body}
        >
            {
                props.closeIconVisible && <Button
                    className={styles.closeButton}
                    onClick={props.onRequestClose}
                >
                    <i className={classNames(iconFont.iconfont, iconFont.iconTuichupx)} />
                </Button>
            }
            {props.children}
        </Box>
    </ReactModal>
);

ModalComponent.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    closeIconVisible: PropTypes.bool,
    contentLabel: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]).isRequired,
    onRequestClose: PropTypes.func,
    overlayClassName: PropTypes.string
};

ModalComponent.defaultProps = {
    closeIconVisible: true
}

export default ModalComponent;
